import { Dialog as DialogPrimitive } from "radix-ui";
import type { ComponentProps } from "react";

export const Dialog = (props: ComponentProps<typeof DialogPrimitive.Root>) => (
  <DialogPrimitive.Root data-slot="dialog" {...props} />
);
